import { SearchOutlined } from '@ant-design/icons';
import { Flex, Input, theme } from 'antd';
import React, { type ReactNode, useEffect, useState } from 'react';
import FilterSelect from '../../../components/controls/filter-select';
import { type MealCategory } from '../../../entities';
import { useQuery } from '../../../jsonapi-provider';

export interface ProductionLineFiltersProps {
  onChange?: (filters: FiltersState) => void;
  initialFilters: FiltersState;
}

interface FiltersState {
  query: string;
  mealCategory?: string[];
  hhcRoute?: number[];
}

const ProductionLinesFilter = (props: ProductionLineFiltersProps): ReactNode => {
  const { initialFilters, onChange } = props;
  const [filters, setFilter] = useState<FiltersState>(initialFilters);
  const { token } = theme.useToken();
  const mealCategories = useQuery<MealCategory[]>([
    'meal-category',
    {
      fields: {
        'meal-category': ['name'],
      },
      sort: 'sortOrder',
      page: {
        size: 10000,
      },
    },
  ]);
  const routes = Array(99)
    .fill(0)
    .map((_, i) => ({ label: i + 1, value: i + 1 }));

  useEffect(() => {
    onChange?.(filters);
  }, [filters]);

  return (
    <Flex gap={token.paddingXS}>
      <Input
        allowClear
        value={filters?.query}
        placeholder="Search"
        prefix={<SearchOutlined />}
        onChange={(e) => {
          setFilter((prev) => ({
            ...prev,
            query: e.target?.value || '',
          }));
        }}
        style={{ maxWidth: 300, marginInlineEnd: token.marginMD }}
      />

      <FilterSelect
        value={filters?.mealCategory}
        canSelectAll
        mode="multiple"
        options={mealCategories.data ?? []}
        optionValueProp="id"
        optionLabelProp="name"
        title="Meal Category"
        onChange={(value) => {
          setFilter((prev) => ({
            ...prev,
            mealCategory: value,
          }));
        }}
      />

      <FilterSelect
        value={filters?.hhcRoute}
        canSelectAll
        mode="multiple"
        options={routes}
        optionValueProp="value"
        optionLabelProp="label"
        title="HHC Route Number"
        onChange={(value) => {
          setFilter((prev) => ({
            ...prev,
            hhcRoute: value,
          }));
        }}
      />
    </Flex>
  );
};
ProductionLinesFilter.defaultProps = {
  onChange: () => {},
};
export default ProductionLinesFilter;
